import React from "react";
import { Link } from "react-router-dom";
class WishList extends React.Component {
  render() {
    let total = 0;
    this.props.list.map((e) => (total += e.price * 0.8 + e.delivery));
    return (
      <div className="cart-products">
        {this.props.list.length === 0 && (
          <h1 className="varela-round">You haven't created your Wishlist: </h1>
        )}
        <div className=" products">
          {this.props.list.map((e) => {
            return (
              <div className="product-card" key={e.id}>
                <span className="badge">{e.bestSeller && "Best Seller"}</span>
                <img src={e.img} alt="" />
                <h3>
                  {e.name}
                  <span className="delivery">
                    {e.id <= 12 ? (
                      <Link to={`/products/${e.id}`}>more info</Link>
                    ) : (
                      <Link to={`/upcoming/${e.id}`}>more info</Link>
                    )}
                  </span>
                </h3>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star-half half-star"></i>
                <Link
                  className="btn btn-buy ml"
                  to="/payments"
                  onClick={() =>
                    this.props.setTotal(e.price * 0.8 + e.delivery, e.id)
                  }
                >
                  Buy
                </Link>
                <button
                  className="btn btn-remove-from-cart"
                  onClick={() => this.props.handleRemove(e)}
                >
                  Remove
                </button>
                <span className="price-badge">
                  ${(0.8 * e.price).toFixed(2)}
                </span>
              </div>
            );
          })}
        </div>
        {this.props.list.length > 0 && (
          <Link
            className="btn btn-checkout"
            to="/payments"
            onClick={() => this.props.setTotal(total)}
          >
            Proceed to checkout
          </Link>
        )}
        <Link className="btn btn-link" to="/products">
          Add Products to WishList
        </Link>
      </div>
    );
  }
}
export default WishList;
